import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AplicacionFormComponent } from './form/aplicacion-form.component';
import { AplicacionListComponent } from './list/aplicacion-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from '../../../../custom-components/dialog/dialog.module';
import { MaterialModule } from '../../../../material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomHeaderModule } from '../../../../custom-components/custom-header/custom-header.module';
import {AplicacionRoutingModule} from './aplicacion-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {AplicacionService} from './aplicacion.service';
import { RouterModule } from '@angular/router';
import {AplicacionTipoService} from '../aplicacion-tipo/aplicacion-tipo.service';
import {EntidadService} from '../../entidad-datos/entidad/entidad.service';

@NgModule({
  declarations: [
    AplicacionFormComponent,
    AplicacionListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MaterialModule,
    CustomHeaderModule,
    FlexLayoutModule,
    AplicacionRoutingModule,
    RouterModule,
    SharedModule,
    AplicacionRoutingModule
  ],
  providers: [AplicacionService, AplicacionTipoService, EntidadService]
})
export class AplicacionModule { }
